/* ============================================================
   scroll-memory.js — put the shopper back where they were.

   Browsers restore vertical scroll on a back navigation, but two
   things in this theme defeat it:

     1. `html { scroll-behavior: smooth }` (base.css) turns the
        browser's instant restore into an animation that is easily
        cancelled, so the page lands at the top.
     2. The homepage rows (products, gallery, lookbook, showcase) are
        horizontal scroll tracks. Their scrollLeft is never restored,
        so a shopper who swiped to the sixth product and opened it came
        back to the first.

   So: remember the vertical position and every track's horizontal
   position when leaving a page, and put them back when the shopper
   returns through the back button. Restoration is abandoned the
   moment the shopper scrolls themselves, so it can never fight them.

   Nothing here runs on a normal forward navigation. A bfcache restore
   (the common case on iOS) already returns the page intact, so this
   only has to cover the browsers and situations that do not.
   ============================================================ */
(function () {
  var PREFIX = 'lanuit:pos:';
  var root = document.documentElement;
  var settled = false;

  var TRACKS = [
    '.featured-collection--row .featured-collection__grid',
    '.lookbook__grid',
    '.product-showcase__track',
    '.product-slider__track',
    '.product-gallery__thumbs',
    '[data-scroll-memory]'
  ].join(',');

  function key() {
    return PREFIX + location.pathname + location.search;
  }

  function tracks() {
    return Array.prototype.slice.call(document.querySelectorAll(TRACKS));
  }

  function save() {
    try {
      var t = {};
      tracks().forEach(function (el, i) {
        if (el.scrollLeft > 0) t[i] = Math.round(el.scrollLeft);
      });
      sessionStorage.setItem(key(), JSON.stringify({
        y: Math.round(window.scrollY || window.pageYOffset || 0),
        t: t
      }));
    } catch (e) {
      /* private mode, storage full: remembering position is optional */
    }
  }

  function read() {
    try {
      return JSON.parse(sessionStorage.getItem(key()) || 'null');
    } catch (e) {
      return null;
    }
  }

  function cameBack() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav) return nav.type === 'back_forward';
      return performance.navigation && performance.navigation.type === 2;
    } catch (e) {
      return false;
    }
  }

  /* The smooth-scroll declaration would animate (and so lose) the jump. */
  function instantly(fn) {
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    fn();
    requestAnimationFrame(function () {
      root.style.scrollBehavior = prev;
    });
  }

  function restore() {
    if (settled) return;
    var data = read();
    if (!data) return;
    instantly(function () {
      tracks().forEach(function (el, i) {
        var x = data.t && data.t[i];
        if (x && Math.abs(el.scrollLeft - x) > 4) el.scrollLeft = x;
      });
      var y = window.scrollY || window.pageYOffset || 0;
      if (data.y && Math.abs(y - data.y) > 4) window.scrollTo(0, data.y);
    });
  }

  function stop() {
    settled = true;
  }

  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save();
  });

  /* An explicit hash in the URL is a stronger intent than a remembered
     position, so leave those pages alone. */
  if (cameBack() && !location.hash) {
    restore();
    document.addEventListener('DOMContentLoaded', restore);
    window.addEventListener('load', function () {
      restore();
      /* Images and web fonts settle a beat after load and can shift the
         page under the restored position. One late pass catches that. */
      setTimeout(restore, 150);
      setTimeout(stop, 700);
    });
    /* The shopper's own scrolling always wins. */
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (evt) {
      window.addEventListener(evt, stop, { passive: true, once: true });
    });
  }
})();
